import { render, staticRenderFns } from "./AddOnAssignCard.vue?vue&type=template&id=57235034&"
import script from "./AddOnAssignCard.vue?vue&type=script&lang=js&"
export * from "./AddOnAssignCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports